<template lang='pug' src='./team-tabcontent.pug'></template>

<script>
import TeamGallery from '../team-gallery/team-gallery'

export default {
  props: ['content'],
  components: {
    TeamGallery
  }
}
</script>



// WEBPACK FOOTER //
// team-tabcontent.vue?3f631bf8